import AddIcon from '@mui/icons-material/Add';
import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import { NodeRendererProps } from 'react-arborist';
import styled from 'styled-components';

import { useState } from 'react';
import { TreeApiData } from '..';
import UploadFileIcon from '../../../../../../../assets/svg/UploadFileIcon';
import Button from '../../../../../../../react-components/Button';
import Text from '../../../../../../../react-components/Text';
import { TREE_ITEM_HEIGHT } from '../PlanOverviewListStyles';

const UnassignedElementContainer = styled(Grid)`
  cursor: pointer;
  height: ${TREE_ITEM_HEIGHT}px;
  padding-right: 6px;
  display: flex;
  align-items: center;
`;

const OptionButton = styled(Button)`
  height: 34px;
  width: 42px;
  padding: 0;
  margin: 0;
  border-radius: 5px;
  border: 1px solid ${RoutalPalette.primary40};
`;

interface UnassignedNoStopsElementProps extends NodeRendererProps<TreeApiData> {
  isDraggable?: boolean;
  setDialog: (dialog: `createStopsManually` | `stopsFromFile` | undefined) => void;
}

export const UnassignedNoStopsElement = ({
  isDraggable = false,
  node,
  style,
  dragHandle,
  setDialog,
}: UnassignedNoStopsElementProps) => {
  const [hover, setHover] = useState<boolean>(false);
  node.isDraggable = isDraggable;

  return (
    <UnassignedElementContainer
      style={{
        ...style,
      }}
      ref={dragHandle}
      onClick={() => node.toggle()}
    >
      <Grid
        container
        direction="row"
        alignItems="center"
        justifyContent="center"
        wrap="nowrap"
        style={{
          height: `52px`,
          borderRadius: `5px`,
          padding: `8px`,
          border: `1px solid ${RoutalPalette.neutral10}`,
          backgroundColor: hover ? RoutalPalette.neutral10 : RoutalPalette.neutral00,
        }}
        onClick={() => setDialog(`stopsFromFile`)}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <Grid container>
          <Text
            variant="small"
            style={{ color: RoutalPalette.secondary00 }}
            intlId="planoverview.unassigned.add_unassigned_stops"
          />
        </Grid>

        <Grid container direction="row" gap="10px" style={{ width: `unset` }} wrap="nowrap">
          <OptionButton variant="flat" onClick={() => setDialog(`createStopsManually`)}>
            <AddIcon style={{ color: RoutalPalette.primary40 }} />
          </OptionButton>

          <OptionButton onClick={() => setDialog(`stopsFromFile`)}>
            <UploadFileIcon color={RoutalPalette.neutral00} />
          </OptionButton>
        </Grid>
        {` `}
      </Grid>
    </UnassignedElementContainer>
  );
};
